/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import authUserModule from './modules/authUserModule.js';
import loyaltyModule from './modules/loyaltyModule'
import offerModule from './modules/offerModule'
import ratingModule from './modules/ratingModule'
import vueOnboardingModule from './modules/vueOnboardingModule'
import policyModule from "./modules/policyModule";
import changeEmailModule from "./modules/changeEmailModule";

Vue.use(Vuex)
const vuexLocalStorage = new VuexPersistence({
    key:"request_change_email",
    storage: window.localStorage, // or window.sessionStorage or localForage
    modules: ['changeEmail'], //only save user module
})
export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        authUser: authUserModule,
        loyalty: loyaltyModule,
        offers: offerModule,
        vueOnboarding: vueOnboardingModule,
        rating: ratingModule,
        policy: policyModule,
        changeEmail: changeEmailModule,
    },
    plugins: [vuexLocalStorage.plugin],
    strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/store.js